'use client';

import React from 'react';
import Layout from '$modules/onboarding/layout';
import { ToastContainer } from '@brahma/components';
const OnboardingLayout = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <Layout data-sentry-element="Layout" data-sentry-component="OnboardingLayout" data-sentry-source-file="layout.tsx">
      {children}
      <ToastContainer data-sentry-element="ToastContainer" data-sentry-source-file="layout.tsx" />
    </Layout>;
};
export default OnboardingLayout;